module.exports = __webpack_public_path__ + "img/sc.4972ecc1.jpg";